import { atom, useAtom, useSetAtom } from 'jotai';

import { ROW_STATUSES } from '../constants/campaignBuilder.js';

// This is a workaround for the issue with circular dependencies.
// Usage of ROW_STATUSES.ALL causes an error because ROW_STATUSES do not exist at this moment.
const initialValue = 'All Rows' as ROW_STATUSES;
const statusAtom = atom<ROW_STATUSES>(initialValue);

export const useStatusOfRows = () => {
  return useAtom(statusAtom);
};

export const useSetStatusOfRows = () => {
  return useSetAtom(statusAtom);
};
